import React from "react";
import HTMLReactParser from "html-react-parser";
import { Col, Row } from "react-bootstrap";
//import shanlyLogo from "../../images/shanly-logo.png";
import shanlyLogo from "../../images/shanly-logo-new.png";
import "./BandSection.scss";

const BandSection = ({ module, image }) => {
  return (
    <Col xl={12} className="mb-4">
      <div className="block home-page band-section">
        <Row className="align-items-stretch">

          {/* LEFT SIDE (IMAGE WITH LOGO OVERLAY) */}
          <Col md={5} className="left-section p-0">
            <div className="image-container">
              
              {/* Background Image */}
              {image && (
                <img src={image} alt="Band Visual" className="img-fluid main-img" />
              )}

              {/* Logo Overlay */}
              <div className="logo-overlay">
                <img src={shanlyLogo} alt="Shanly Homes" />
              </div>

            </div>
          </Col>

          {/* RIGHT SIDE */}
          <Col md={7} className="right-section">
            
            {module?.Title && <h2>{module.Title}</h2>}

            {module?.Content && (
              <div className="content">
                {HTMLReactParser(module.Content.replace(/\n/g, "<br />"))}
              </div>
            )}

          </Col>

        </Row>
      </div>
    </Col>
  );
};

export default BandSection;